export const statusObj = {
  Open: "O",
  Palletize: "P",
  Cancelled: "C",
  Received: "R",
  Recv: "R",
  ASN_CO_RECV: "A",
  Cancel: "C",
  NotEnoughStock: "N",
  BackOrder:"B",
  Hold:"H",
  Completed:"D"
};

export const statusLabel = {
  O: "Open",
  R: "Received",
  C: "Cancel",
  I: "InUse",
  A: "ASN_CO_RECV",
  N: "NotEnoughStock",
  B:"BackOrder",
  H:"Hold"
};
export const soStatusLabel = { O: "Open", C: "Cancel", A: "Allocate", N: "NotEnoughStock",B:"BackOrder" };
export const poTypeLabel = {
  B: "Blanket",
  S: "Standard",
};

export const palletTypeObj = {
  SMALL: { label: "Small Pallet", value: "SMALL" },
  STANDARD: { label: "Standard Pallet", value: "STANDARD" },
  LARGE: { label: "Large Pallet", value: "LARGE" },
};
